export type Bilingual = {
  it: string;
  en: string;
};

export const tattooStyles = [
  'blackwork',
  'fineline',
  'handpoke',
  'lettering',
  'dotwork',
  'ornamental',
] as const;

export type TattooStyle = (typeof tattooStyles)[number];

export const styleLabels: Record<TattooStyle, Bilingual> = {
  blackwork: { it: 'Blackwork', en: 'Blackwork' },
  fineline: { it: 'Fine line', en: 'Fine line' },
  handpoke: { it: 'Handpoke', en: 'Handpoke' },
  lettering: { it: 'Lettering', en: 'Lettering' },
  dotwork: { it: 'Dotwork', en: 'Dotwork' },
  ornamental: { it: 'Ornamentale', en: 'Ornamental' },
};

export type Artist = {
  slug: string;
  name: string;
  alias: string;
  since: number;
  origin: string;
  basedIn: string;
  styles: TattooStyle[];
  instagram: string;
  portrait: string;
  bio: Bilingual;
  manifesto: Bilingual;
};

export type WorkStoryChapter = {
  /** Mono number rendered as eyebrow (e.g. "01"). */
  index: string;
  /** Date stamp like "2025 — 04" or "Seduta 1 · 2h". */
  stamp: Bilingual;
  /** Chapter title — short, editorial. */
  title: Bilingual;
  /** Body copy — one paragraph, voice of the studio. */
  body: Bilingual;
  /** Optional image (URL). Layout alternates side per chapter index. */
  image?: string;
};

export type Work = {
  id: string;
  title: Bilingual;
  artistSlug: string;
  style: TattooStyle;
  placement: Bilingual;
  size: string;
  hours: number;
  year: number;
  image: string;
  alt: Bilingual;
  description?: Bilingual;
  /** Long-form narrative diary — when present, the work has a dedicated detail page. */
  story?: WorkStoryChapter[];
};

export type StudioHours = {
  days: Bilingual;
  time: Bilingual;
};

export type StudioInfo = {
  legalName: string;
  brand: string;
  tagline: Bilingual;
  address: { street: string; city: string; zip: string };
  email: string;
  phone: string;
  instagram: string;
  hours: StudioHours[];
  ethos: Bilingual;
  process: Array<{
    step: number;
    title: Bilingual;
    body: Bilingual;
  }>;
  faq: Array<{
    q: Bilingual;
    a: Bilingual;
  }>;
  numbers: Array<{
    value: string;
    label: Bilingual;
  }>;
};
